import * as React from 'react';
import { AppUtils } from '../../utils/app-utils';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id          : string;
    label       : string;
    value       : any;
    onChange    : any;
    className?  : string;
    error?      : any;
    disable?    : boolean;
    name?       : string;
    onBlur?     : any;
}

// #endregion

const TelephoneInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        value, 
        onChange, 
        disable, 
        name,
        onBlur
    } = props;

    const changeInterceptor = (e : any) => {
        if (e.target.value.length > 14) {
            return;
        }
        else {
            onChange(e);
        }
    };

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <input
                id={id}
                className={"form-control" + ( error ? ' error-outline' : '')}
                type="tel"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                name={name}
                disabled={disable}
                autoComplete="off"
                value={ AppUtils.formatPhone(value) }
                onChange={ changeInterceptor }
                onBlur={ onBlur }
            />
            <InputFeedback error={error} />
        </div>
    );
};

TelephoneInput.defaultProps = {
    className   : '',
    error       : undefined,
    disable     : false,
    name        : '',
    onBlur      : undefined
};

export { TelephoneInput };
